import { cn } from '@/lib/utils'
import { HtmlHTMLAttributes } from 'react'

interface CompType {
  sm?: boolean
  center?: boolean
  link?: boolean
}

export default function Text({
  className,
  sm,
  link,
  center,
  ...props
}: HtmlHTMLAttributes<HTMLParagraphElement> & CompType) {
  return (
    <p
      {...props}
      className={cn(
        'text-2xl text-dark',
        { 'text-sm': sm },
        { 'cursor-pointer text-primary hover:text-primary/80': link },
        { 'mx-auto text-center': center },
        className
      )}
    />
  )
}
